module.exports = __webpack_public_path__ + "static/media/favorite-fill.87756302.svg";